<template>
  <div class="button-list" @click.stop>
    <div class="filter-button" :class="state.date.created_active ? 'active' : ''" @click.stop="toggleDateCreated">
      <div class="filter-button__title">
        {{
          state.date.created_from && state.date.created_to ? `от ${formatDate(state.date.created_from)} до ${formatDate(state.date.created_to)}`
              : state.date.created_from ? `от ${formatDate(state.date.created_from)}` : state.date.created_to ? `до ${formatDate(state.date.created_to)}` : 'Дата создания'
        }}
      </div>
      <div class="filter-button__icon">
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5 0C4.44772 0 4 0.447715 4 1V3H2C0.895431 3 0 3.89543 0 5V19C0 20.1046 0.895431 21 2 21H6.25H7.75H12.25H13.75H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3H16V1C16 0.447715 15.5523 0 15 0C14.4477 0 14 0.447715 14 1V3H6V1C6 0.447715 5.55228 0 5 0ZM18 19.5H13.75V15.25H18.5V19C18.5 19.2761 18.2761 19.5 18 19.5ZM18.5 13.75H13.75V10.25H18.5V13.75ZM12.25 13.75V10.25H7.75V13.75H12.25ZM6.25 13.75V10.25H1.5V13.75H6.25ZM1.5 15.25H6.25V19.5H2C1.72386 19.5 1.5 19.2761 1.5 19V15.25ZM7.75 15.25H12.25V19.5H7.75V15.25ZM14 4.5H6V5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5V4.5H2C1.72386 4.5 1.5 4.72386 1.5 5V8.75H18.5V5C18.5 4.72386 18.2761 4.5 18 4.5H16V5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5V4.5Z"
                fill="currentColor"/>
        </svg>
      </div>
      <transition name="fade">
        <div class="tooltip" v-if="state.date.created_active" @click.stop>
          <div class="page__row mb-20">
            <div class="page__item">
              <AppInputDate title="от"
                            :value="state.date.created_from"
                            :valid="{}"
                            type="single"
                            width="160px"
                            @value-changed="setCreatedFrom"
              />
            </div>
            <div class="page__item">
              <AppInputDate title="до"
                            :value="state.date.created_to"
                            :valid="{}"
                            type="single"
                            width="160px"
                            @value-changed="setCreatedTo"
              />
            </div>
          </div>
          <div class="page__row">
            <div class="page__item">
              <AppButton title="Применить"
                         type="main"
                         @click.stop.native="applyDate"
              />
            </div>
            <div class="page__item">
              <AppButton title="Сбросить"
                         type="alt"
                         @click.stop.native="clearDateCreated"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="filter-button" :class="state.date.finish_active ? 'active' : ''" @click.stop="toggleDateFinish">
      <div class="filter-button__title">
        {{
          state.date.finish_from && state.date.finish_to ? `от ${formatDate(state.date.finish_from)} до ${formatDate(state.date.finish_to)}`
              : state.date.finish_from ? `от ${formatDate(state.date.finish_from)}` : state.date.finish_to ? `до ${formatDate(state.date.finish_to)}` : 'Дата закрытия'
        }}
      </div>
      <div class="filter-button__icon">
        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5 0C4.44772 0 4 0.447715 4 1V3H2C0.895431 3 0 3.89543 0 5V19C0 20.1046 0.895431 21 2 21H6.25H7.75H12.25H13.75H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3H16V1C16 0.447715 15.5523 0 15 0C14.4477 0 14 0.447715 14 1V3H6V1C6 0.447715 5.55228 0 5 0ZM18 19.5H13.75V15.25H18.5V19C18.5 19.2761 18.2761 19.5 18 19.5ZM18.5 13.75H13.75V10.25H18.5V13.75ZM12.25 13.75V10.25H7.75V13.75H12.25ZM6.25 13.75V10.25H1.5V13.75H6.25ZM1.5 15.25H6.25V19.5H2C1.72386 19.5 1.5 19.2761 1.5 19V15.25ZM7.75 15.25H12.25V19.5H7.75V15.25ZM14 4.5H6V5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5V4.5H2C1.72386 4.5 1.5 4.72386 1.5 5V8.75H18.5V5C18.5 4.72386 18.2761 4.5 18 4.5H16V5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5V4.5Z"
                fill="currentColor"/>
        </svg>
      </div>
      <transition name="fade">
        <div class="tooltip" v-if="state.date.finish_active" @click.stop>
          <div class="page__row page__row_between mb-20">
            <div class="page__item">
              <AppInputDate title="от"
                            :value="state.date.finish_from"
                            :valid="{}"
                            type="single"
                            width="160px"
                            @value-changed="setFinishFrom"
              />
            </div>
            <div class="page__item">
              <AppInputDate title="до"
                            :value="state.date.finish_to"
                            :valid="{}"
                            type="single"
                            width="160px"
                            @value-changed="setFinishTo"
              />
            </div>
          </div>
          <div class="page__row">
            <div class="page__item">
              <AppButton title="Применить"
                         type="main"
                         @click.stop.native="applyDate"
              />
            </div>
            <div class="page__item">
              <AppButton title="Сбросить"
                         type="alt"
                         @click.stop.native="clearDateFinish"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="filter-button" :class="state.list.active ? 'active' : ''" @click.stop="toggleList">
      <div class="filter-button__title">{{ state.list.current }}</div>
      <div class="filter-button__icon">
        <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 2H20" stroke="currentColor" stroke-width="2"/>
          <path d="M0 11H20" stroke="currentColor" stroke-width="2"/>
          <circle cx="7" cy="2" r="2" fill="currentColor"/>
          <circle cx="13" cy="11" r="2" fill="currentColor"/>
        </svg>
      </div>
      <transition name="fade">
        <div class="popup-menu" v-if="state.list.active" @click.stop>
          <ul class="popup-menu__list">
            <li class="popup-menu__item">
              <div class="popup-menu__link" @click.stop="clearFilter">
                <p class="popup-menu__text">{{ state.list.clear }}</p>
              </div>
            </li>
            <li class="popup-menu__item">
              <div class="popup-menu__link" @click.stop="setInProgress">
                <p class="popup-menu__text">{{ state.list.inProgress }}</p>
              </div>
            </li>
            <li class="popup-menu__item">
              <div class="popup-menu__link" @click.stop="setCreated">
                <p class="popup-menu__text">{{ state.list.created }}</p>
              </div>
            </li>
            <li class="popup-menu__item">
              <div class="popup-menu__link" @click.stop="setWatch">
                <p class="popup-menu__text">{{ state.list.watch }}</p>
              </div>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

import AppInputDate from '@/components/page/input/AppInputDate'
import AppButton from '@/components/page/button/AppButton'
import { formatDate } from '@/utils/utils'

export default {
  name: 'buttons-filter',
  components: {
    AppButton,
    AppInputDate
  },
  props: {
    state: {
      type: Object,
      default: () => {
        return ({
          date: {
            active: false,
            date_start: '',
            date_finish: ''
          },
          list: {
            active: false,
            all: '',
            inProgress: '',
            created: '',
            watch: ''
          }
        })
      }
    }
  },
  computed: {},
  methods: {
    toggleDateCreated () {
      this.$emit('toggle-date-created')
    },
    setCreatedFrom (date) {
      this.$emit('set-date-created-from', date)
    },
    setCreatedTo (date) {
      this.$emit('set-date-created-to', date)
    },
    clearDateCreated () {
      this.$emit('clear-date-created')
    },
    toggleDateFinish () {
      this.$emit('toggle-date-finish')
    },
    setFinishFrom (date) {
      this.$emit('set-date-finish-from', date)
    },
    setFinishTo (date) {
      this.$emit('set-date-finish-to', date)
    },
    applyDate () {
      this.$emit('apply-date')
    },
    clearDateFinish () {
      this.$emit('clear-date-finish')
    },
    toggleList () {
      this.$emit('toggle-list')
    },
    clearFilter () {
      this.$emit('clear-filter')
    },
    setInProgress () {
      this.$emit('inProgress-filter')
    },
    setCreated () {
      this.$emit('created-filter')
    },
    setWatch () {
      this.$emit('watch-filter')
    },
    formatDate (date) {
      return formatDate(date)
    }
  },
  mounted () {}
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.button-list {
  position: relative;
  z-index: 999;
  display: flex;
  flex-flow: row nowrap;
}

.filter-button {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px 0 14px;
  width: 200px;
  height: 40px;
  border: 1px solid #DFE1EC;
  border-radius: 3px;
  color: $color-second-light;
  background: $color_sixth;
  cursor: pointer;
  margin-right: 10px;
  transition: .3s;

  &__title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__icon {
    margin-left: auto;
  }

  &.active {
    background: $color_second-light;
    color: $font_color_alt;
  }

  &:last-child {
    margin-right: 0;
  }

  &:hover {
    background: $color_second-light;
    color: $font_color_alt;
  }
}

.tooltip {
  position: absolute;
  z-index: 2;
  top: calc(100% + 15px);
  left: calc(50% - 203px);
  display: flex;
  flex-flow: column nowrap;
  background-color: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  padding: 30px;
  cursor: auto;

  .page__item {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -6px;
    left: 50%;
    margin: 0 auto;
    width: 10px;
    height: 10px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(45deg);
  }
}

.apply-button-wrap {
  justify-content: center;
}

.popup-menu {
  position: absolute;
  top: calc(100% + 15px);
  left: 0;
  width: 100%;
  background-color: $color_main;
  border: 1px solid $border_color;
  border-radius: 3px;

  &__item {
    &:last-child {
      .popup-menu__link {
        border-bottom: none;
      }
    }
  }

  &__link {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 14px;
    min-height: 50px;
    cursor: pointer;
    transition: .3s;
    border-bottom: 1px solid $border_color;
    color: $font_color_main;

    &:hover {
      background-color: $color_second-light;
      color: $font_color_alt;
    }
  }

  &__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -6px;
    left: 50%;
    margin: 0 auto;
    width: 10px;
    height: 10px;
    background: linear-gradient(-45deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, $color_main 50%, $color_main 100%);
    border: 1px solid $border_color;
    border-bottom: none;
    border-right: none;
    transform: rotate(45deg);
  }
}
</style>
